import { appMainServerInstance, adminServerInstance } from "../axios/instances";
import { 
    ADD_HOLDING_PACKAGES,
    ADD_HOLDING_PACKAGES_SUCCESS,
    ADD_HOLDING_PACKAGES_FAIL,
    GET_HOLDING_REPORT,
    GET_HOLDING_REPORT_SUCCESS,
    GET_HOLDING_REPORT_FAIL,
    GET_HOLDING_KEY,
    GET_HOLDING_KEY_SUCCESS,
    GET_HOLDING_KEY_FAIL,
    CANCEL_BATCH,
    CANCEL_BATCH_SUCCESS,
    CANCEL_BATCH_FAIL,
    CANCEL_TNO,
    CANCEL_TNO_SUCCESS,
    CANCEL_TNO_FAIL,
    ADD_HOLDING_PACKAGE_BY_BAGS,
    ADD_HOLDING_PACKAGE_BY_BAGS_SUCCESS,
    ADD_HOLDING_PACKAGE_BY_BAGS_FAIL,
    HANDLE_BLOCK_BATCH
 } from './types';

export function handleReturnedBlockBatch(blockBatch) {
    return function(dispatch){
    dispatch({type: HANDLE_BLOCK_BATCH})
    return (
        dispatch({
            type: HANDLE_BLOCK_BATCH,
            payload: blockBatch
        })
    )}
}

export function addHoldingPackageByBags(bag_nos, warehouse,notes) {
    return function(dispatch) {
        dispatch({type: ADD_HOLDING_PACKAGE_BY_BAGS})
        return adminServerInstance.post("/cargo/addholdingpackagebybags", {
            bag_nos: bag_nos,
            warehouse: warehouse,
            notes: notes
        })
        .then(({data}) => {
            dispatch({
                type: ADD_HOLDING_PACKAGE_BY_BAGS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: ADD_HOLDING_PACKAGE_BY_BAGS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function cancelTno(tnos, warehouse) {   
    return function(dispatch) {
        dispatch({type: CANCEL_TNO})
        return adminServerInstance.post(`/cargo/cancelholdingordersbytnos`, {
            tnos: tnos,
            scan_location: warehouse
        })
        .then(({data}) => {
            dispatch({
                type: CANCEL_TNO_SUCCESS,
                payload: data.data.config
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: CANCEL_TNO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function cancelBatch(blk_batch_nos, warehouse) {   
    return function(dispatch) {
        dispatch({type: CANCEL_BATCH})
        return adminServerInstance.post(`/cargo/cancelholdingorders`, {
            blk_batch_nos: blk_batch_nos,
            scan_location: warehouse
        })
        .then(({data}) => {
            dispatch({
                type: CANCEL_BATCH_SUCCESS,
                payload: data.data.config
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: CANCEL_BATCH_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getHoldingKey() {   
    return function(dispatch) {
        dispatch({type: GET_HOLDING_KEY})
        return adminServerInstance.get(`/driver/getholdingkey`)
        .then(({data}) => {
            dispatch({
                type: GET_HOLDING_KEY_SUCCESS,
                payload: data.data.config
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_HOLDING_KEY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * @param {Object} params
 * @param {string} params.warehouse
 * @param {string} params.tnos
 * @param {Number} params.ignore_state
 * @param {string} params.notes
 * @param {string} params.operator
 */
export function addHoldingPackages(params) {   
    return function(dispatch) {
        dispatch({type: ADD_HOLDING_PACKAGES})
        return adminServerInstance.post("/cargo/addholdingpackages", params)
        .then(({data}) => {
            dispatch({
                type: ADD_HOLDING_PACKAGES_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: ADD_HOLDING_PACKAGES_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getHoldingReport(warehouse, blockBatch, sortBy) {   
    return function(dispatch) {
        dispatch({type: GET_HOLDING_REPORT})
        return appMainServerInstance.get(`/cargo/getholdingreport?warehouse=${warehouse}&block_batch=${blockBatch}&sort_by=${sortBy}`)
        .then(({data}) => {
            dispatch({
                type: GET_HOLDING_REPORT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_HOLDING_REPORT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}